import React, { FC } from "react";
import ProgressiveImage from "react-progressive-graceful-image";
import {heroImage, tinyHeroImage} from '../../../../assets';
import './HeroBanner.css';
import { useNavigate } from "react-router-dom";


const HeroBanner:FC = () => {

    const navigate = useNavigate()

    return(
        <div className="hero">
            <div className="hero-content">
                <h1 className="title">Unlock Your Financial Potential with One Life</h1>
                <p className="blurb">
                    At One Life Equity, we provide commercial private equity funding solutions to help businesses thrive. 
                    Discover how we can fuel your growth today.
                </p>
                <button className="application-btn" onClick={()=>navigate('/loan-application-form')} >Start Application</button>
            </div>
            <div className="hero-image">
            <ProgressiveImage src={heroImage} placeholder={tinyHeroImage}>
                {(src)=><img src={src} alt="Hero" />}
            </ProgressiveImage>
            </div>
        </div>
    )
}

export default HeroBanner;